import React from 'react';
import './Footer.css';

const EMAIL = 'varellasambista@gmail.com';

const quickLinks = [
  { name: 'Esculturas', href: '#gallery' },
  { name: 'Destaques', href: '#highlights' },
  { name: 'Música', href: '#music' },
  { name: 'Audiovisual', href: '#audiovisual' },
  { name: 'Textos', href: '#written-works' },
  { name: 'Projetos', href: '#projects' },
  { name: 'Trajetória', href: '#biography' },
  { name: 'Contato', href: '#contact' }
];

// Troque os "#" pelas URLs reais; os placeholders não são renderizados como links.
const socialLinks = [
  { name: 'YouTube', url: 'https://www.youtube.com/playlist?list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM' },
  { name: 'Instagram', url: '#' },
  { name: 'Facebook', url: 'https://www.facebook.com/antonio.sambista' },
  { name: 'Palco MP3', url: 'https://www.palcomp3.com.br/varellasambista/' },
  { name: 'Spotify', url: '#' }
];

const contactInfo = [
  { title: 'Telefone', info: '+55 24 99209-5750', href: 'tel:+5524992095750' },
  { title: 'Email', info: EMAIL, href: `mailto:${EMAIL}` },
  { title: 'Localização', info: 'Barra Mansa — RJ, Brasil' }
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (href) => {
    const el = document.getElementById(href.substring(1));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand-section">
            <h3 className="footer-title">Varella</h3>
            <p className="footer-subtitle">Sambista · Escultor · Poeta</p>
            <p className="footer-description">
              A alma do samba e a força do barro — arte que conecta tradição e raízes brasileiras.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Navegação</h4>
            <nav className="footer-nav">
              {quickLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="footer-link"
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contato</h4>
            <div className="footer-contact">
              {contactInfo.map((item, index) => (
                <div key={index} className="footer-contact-item">
                  <span className="footer-contact-title">{item.title}</span>
                  {item.href ? (
                    <a href={item.href} className="footer-contact-info">{item.info}</a>
                  ) : (
                    <span className="footer-contact-info">{item.info}</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Redes</h4>
            <div className="footer-social">
              {socialLinks.map((social) =>
                social.url === '#' ? (
                  <span key={social.name} className="footer-social-link is-soon">
                    {social.name}
                  </span>
                ) : (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-link"
                  >
                    {social.name}
                  </a>
                )
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Varella Sambista. Todos os direitos reservados.
          </p>
          <button className="footer-scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Voltar ao topo">
            ↑ Topo
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
